import { render, staticRenderFns } from "./cityTree.vue?vue&type=template&id=19228d94&scoped=true"
import script from "./cityTree.vue?vue&type=script&lang=js"
export * from "./cityTree.vue?vue&type=script&lang=js"
import style0 from "./cityTree.vue?vue&type=style&index=0&id=19228d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19228d94",
  null
  
)

export default component.exports